import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { DefectDojoApi } from './DefectDojoApi';
import {
  DefectDojoProduct,
  Finding,
  Engagement,
  PaginatedResponse,
  PaginationParams,
} from '../utils/types';

export class DefectDojoClient implements DefectDojoApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  private async getBaseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('defect-dojo');
  }

  private async request<T>(path: string): Promise<T> {
    const baseUrl = await this.getBaseUrl();
    const res = await this.fetchApi.fetch(`${baseUrl}${path}`);
    if (!res.ok) {
      const body = await res.json().catch(() => ({})) as any;
      throw new Error(
        body?.error?.message ?? `Request failed with status ${res.status}`,
      );
    }
    return res.json() as Promise<T>;
  }

  async getProduct(productId: number): Promise<DefectDojoProduct> {
    return this.request(`/products/${productId}`);
  }

  async getFindings(
    productId: number,
    params?: PaginationParams,
  ): Promise<PaginatedResponse<Finding>> {
    const qs = new URLSearchParams({ product_id: String(productId) });
    if (params?.limit !== undefined) qs.set('limit', String(params.limit));
    if (params?.offset !== undefined) qs.set('offset', String(params.offset));
    return this.request(`/findings?${qs}`);
  }

  async getEngagements(
    productId: number,
    params?: PaginationParams,
  ): Promise<PaginatedResponse<Engagement>> {
    const qs = new URLSearchParams({ product_id: String(productId) });
    if (params?.limit !== undefined) qs.set('limit', String(params.limit));
    if (params?.offset !== undefined) qs.set('offset', String(params.offset));
    return this.request(`/engagements?${qs}`);
  }
}
